import { withIcon } from './withIcon';

const PrintfulSvg = () => (
  <svg
    width="3.25em"
    height="1em"
    viewBox="0 0 104 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M38.4189 11.8253C38.1344 11.4542 37.7757 11.1697 37.3551 10.9842C36.9222 10.7615 36.4398 10.6378 35.9574 10.6626H31.4425V21.3127H33.8669V17.874H36.0069C36.4893 17.8864 36.9593 17.7874 37.4046 17.6019C37.8128 17.4163 38.1839 17.1442 38.4684 16.8102C38.7653 16.4639 39.0003 16.068 39.1611 15.6475C39.3095 15.2146 39.3837 14.7569 39.3961 14.2992C39.3961 13.8539 39.2972 13.4086 39.1116 13.0004C38.9879 12.5798 38.7034 12.2088 38.4189 11.8253ZM36.6501 15.363C36.4645 15.5856 36.1924 15.7217 35.9079 15.7341H33.904V12.8025H35.809C35.9574 12.7901 36.1058 12.8149 36.2295 12.9014C36.3656 13.0004 36.514 13.0375 36.6006 13.1736C36.7367 13.2973 36.8356 13.4581 36.8851 13.6436C36.9469 13.8539 36.9717 14.0766 36.9841 14.2992C36.9841 14.7569 36.8851 15.128 36.6501 15.363Z"
      fill="currentColor"
    />
    <path
      d="M47.3993 16.8102C47.622 16.5999 47.8075 16.3402 47.9559 16.068C48.1044 15.8083 48.2157 15.5238 48.2775 15.2269C48.3765 14.9301 48.426 14.6084 48.4136 14.2992C48.4136 13.8539 48.3147 13.4086 48.1291 13.0004C47.9559 12.5675 47.7085 12.1716 47.3869 11.8377C47.0777 11.479 46.7066 11.1945 46.2737 10.9965C45.8407 10.7739 45.3583 10.6626 44.8759 10.6749H40.0765V21.3251H42.6123V17.8864H44.1956L46.3355 21.3251H49.0816L46.6695 17.3669C46.9416 17.2184 47.189 17.0329 47.3993 16.8102ZM45.5439 15.3259C45.3831 15.5856 45.0986 15.7341 44.8017 15.7464H42.5628L42.5133 12.8643H44.7027C45.012 12.852 45.2965 13.0004 45.4944 13.2354C45.7418 13.5199 45.8779 13.8786 45.8655 14.2621C45.8655 14.7198 45.7789 15.0414 45.5439 15.3259Z"
      fill="currentColor"
    />
    <path
      d="M52.149 10.6626H49.6875V21.2756H52.149V10.6626Z"
      fill="currentColor"
    />
    <path
      d="M60.1027 16.8968L55.1672 10.6626H53.2623V21.2756H55.7362V15.2269L60.6222 21.2756H62.5642V10.6626H60.1027V16.8968Z"
      fill="currentColor"
    />
    <path
      d="M63.1704 12.8025H66.436V21.2756H68.8975V12.8025H72.1136V10.6626H63.1704V12.8025Z"
      fill="currentColor"
    />
    <path
      d="M72.7073 21.2756H75.1812V17.0824H79.09V15.0909H75.1812V12.8025H79.9187V10.6626H72.7073V21.2756Z"
      fill="currentColor"
    />
    <path
      d="M87.3157 16.0681C87.3281 16.4639 87.3034 16.8473 87.2168 17.2308C87.1673 17.5771 87.0436 17.9111 86.8457 18.208C86.6601 18.4801 86.4251 18.7275 86.153 18.9007C85.8314 19.0986 85.4603 19.1975 85.0768 19.1728C84.7181 19.1728 84.3718 19.0986 84.0502 18.9378C83.778 18.7522 83.5307 18.5172 83.3575 18.2327C83.0111 17.5771 82.838 16.835 82.8503 16.0928V10.6502H80.3888V16.0928C80.3888 16.7731 80.4754 17.4411 80.6609 18.0967C80.8217 18.7028 81.1062 19.2718 81.5021 19.7665C81.8855 20.2613 82.3803 20.6572 82.9493 20.9293C83.642 21.2262 84.3842 21.3622 85.1387 21.3498C85.9303 21.3498 86.6725 21.2138 87.2291 20.9293C87.7858 20.6695 88.2806 20.2861 88.6764 19.816C89.0598 19.3212 89.3443 18.7522 89.5175 18.1461C89.7154 17.4782 89.802 16.7855 89.802 16.0928V10.6502H87.3405V16.0681H87.3157Z"
      fill="currentColor"
    />
    <path
      d="M93.55 19.1357V10.6626H91.0885V21.2756H98.671V19.1357H93.55Z"
      fill="currentColor"
    />
    <path
      d="M5.26855 21.3498L11.5028 10.6625L17.7247 21.3498H5.26855Z"
      fill="#F2C994"
    />
    <path
      d="M10.8967 21.3498L17.131 10.6625L23.3529 21.3498H10.8967Z"
      fill="#ED4642"
    />
    <path
      d="M16.5496 21.3498L22.7838 10.6625L29.0057 21.3498H16.5496Z"
      fill="#17BCB5"
    />
    <path
      d="M10.8967 21.3498H17.7495L14.3107 15.499L10.8967 21.3498Z"
      fill="#DF392F"
    />
    <path
      d="M16.5 21.3498H23.3404L19.9511 15.5113L16.5 21.3498Z"
      fill="#16342F"
    />
    <path
      d="M16.5 21.3498H17.7617L17.1308 20.2984L16.5 21.3498Z"
      fill="#15291A"
    />
  </svg>
);

export const Printful = withIcon(PrintfulSvg);
